export class RaceFilter {
  constructor(
    private upcomingMonth?: string,
    private recommended?: boolean,
    private name?: string,
    private ascent?: number,
    private descent?: number,
    private length?: number,
    private raceStart?: Date,
    private raceEnd?: Date,
    private statusFilter?: number) {
  }

  static createRecommendRacesFilter(): RaceFilter {
    var raceFilter: RaceFilter = new RaceFilter();
    raceFilter.upcomingMonth = "0";
    return raceFilter;
  }


  static createRaceFilter(params?: RaceFilterParams): RaceFilter{
    var raceFilter: RaceFilter = new RaceFilter();
     raceFilter.recommended = params?.recommended;
     raceFilter.name = params?.name;
     raceFilter.ascent = params?.ascent;
     raceFilter.descent = params?.descent;
     raceFilter.length = params?.length;
     raceFilter.raceStart = params?.raceStart;
     raceFilter.raceEnd = params?.raceEnd;
     raceFilter.statusFilter = params?.statusFilter;
     raceFilter.upcomingMonth = params?.upcomingMonth;
    return raceFilter;
  }
}

export interface RaceFilterParams {
   upcomingMonth?: string,
   recommended?: boolean,
   name?: string,
   ascent?: number,
   descent?: number,
   length?: number,
   raceStart?: Date,
   raceEnd?: Date,
   statusFilter?: number
}
